import jwtDecode from "jwt-decode";
import { secretbox, randomBytes } from "tweetnacl";
import { decodeUTF8, encodeUTF8, encodeBase64, decodeBase64 } from "tweetnacl-util";

import { Permissions, User } from "../../../apps/vite-app/src/utils/fetcher/auth";

const ENCODING_KEY = "rfNQmiRV8sLm14Fo7QzzWvONSctkoIEUVbFRmxnUMK8=";

const newNonce = () => randomBytes(secretbox.nonceLength);

export const encryptData = (json: object) => {
  const keyUint8Array = decodeBase64(ENCODING_KEY);

  const nonce = newNonce();
  const messageUint8 = decodeUTF8(JSON.stringify(json));
  const box = secretbox(messageUint8, nonce, keyUint8Array);

  const fullMessage = new Uint8Array(nonce.length + box.length);
  fullMessage.set(nonce);
  fullMessage.set(box, nonce.length);

  const base64FullMessage = encodeBase64(fullMessage);
  return base64FullMessage;
};

export const decryptData = (messageWithNonce: string) => {
  const keyUint8Array = decodeBase64(ENCODING_KEY);
  const messageWithNonceAsUint8Array = decodeBase64(messageWithNonce);
  const nonce = messageWithNonceAsUint8Array.slice(0, secretbox.nonceLength);
  const message = messageWithNonceAsUint8Array.slice(
    secretbox.nonceLength,
    messageWithNonce.length
  );

  const decrypted = secretbox.open(message, nonce, keyUint8Array);

  if (!decrypted) {
    throw new Error("Could not decrypt message");
  }

  const base64DecryptedMessage = encodeUTF8(decrypted);
  return JSON.parse(base64DecryptedMessage);
};

export const encryptAuthToken = (authToken: string, user: User, permissions: Permissions) => {
  const decodeToken: { exp?: string; role?: string; user_id?: number } = jwtDecode(authToken);

  return encryptData(
    JSON.stringify({
      jwt: authToken,
      email: user?.email,
      name: user?.name,
      expToken: decodeToken?.exp,
      role: decodeToken?.role,
      userId: decodeToken?.user_id,
      profilePicture: user?.profile_picture,
      permissions: permissions,
      ...(user?.partner && { partner: user?.partner }),
    })
  );
};
